import { apiRequest } from './client'

export interface NuxTooltipDismissalsResponse {
  dismissed_tooltip_ids: string[]
}

export async function getNuxTooltipDismissals(): Promise<string[]> {
  const response = await apiRequest<NuxTooltipDismissalsResponse>('/user/nux-tooltips/dismissals')
  return response.dismissed_tooltip_ids
}

export async function dismissNuxTooltip(tooltipId: string): Promise<void> {
  await apiRequest<void>(`/user/nux-tooltips/${encodeURIComponent(tooltipId)}/dismiss`, {
    method: 'POST',
  })
}
